import { useEffect } from "react";

import { LinearProgress } from "@material-ui/core";
import { LoadedFilesList } from "./LoadedFiles/LoadedFilesList";
import ConfirmButton from "../../common/components/ConfirmButton";

const TerminatedCandidates = ({
  loadFiles,
  createFiles,
  fileLoad,
  finalizeFile,
  loadDetails,
  removeLoanFromFile,
}) => {
  useEffect(() => {
    loadFiles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <ConfirmButton
        label="Create Files"
        action={() => {
          createFiles();
        }}
      />
      {fileLoad.fetching ? <LinearProgress /> : undefined}
      {fileLoad.fetched ? (
        <LoadedFilesList
          data={fileLoad.data}
          {...{ finalizeFile, loadDetails, removeLoanFromFile }}
        />
      ) : undefined}
    </div>
  );
};

export default TerminatedCandidates;
